import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "instagram-collection-page" }
const _hoisted_2 = {
  key: 1,
  class: "instagram-collection-page__media-grid"
}

import { navigateKey, pageKey } from '@drapejs/core';
import { computed, inject } from 'vue';
import UGCMedia from '@/components/UGCMedia/UGCMedia.vue';
import useMeta from '@/composables/useMeta';
import useUGCMedia from '@/composables/useUGCMedia';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramCollectionPage',
  setup(__props) {

const navigate = inject(navigateKey);
const page = inject(pageKey);

useMeta();

const ugcSearchArgs = computed(() => {
  const args = fields.value.UGCSearchArgs;
  if (!args) return {};
  try {
    return JSON.parse(args);
  } catch (e) {
    return {};
  }
});

const { remainingMedia } = useUGCMedia(ugcSearchArgs, null);

const blocks = computed(() => page?.value.blocks);
const fields = computed(() => page?.value.fields || {});
const hasMedia = computed(() => remainingMedia.value.length > 0);

function handleProductTagClick(tag) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  navigate!(tag.variant.url);
}

return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(blocks).Main)
      ? (_openBlock(), _createBlock(_component_blocks_repeater, {
          key: 0,
          blocks: _unref(blocks).Main
        }, null, 8, ["blocks"]))
      : _createCommentVNode("", true),
    (_unref(hasMedia))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(remainingMedia), (item) => {
            return (_openBlock(), _createBlock(UGCMedia, _mergeProps({
              key: (item as any).imageId
            }, (item as any), { onProductClick: handleProductTagClick }), null, 16))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(blocks).Bottom)
      ? (_openBlock(), _createBlock(_component_blocks_repeater, {
          key: 2,
          blocks: _unref(blocks).Bottom
        }, null, 8, ["blocks"]))
      : _createCommentVNode("", true)
  ]))
}
}

})